import { render } from "./contractOverviewTable.vue?vue&type=template&id=3b4addd6&ts=true"
import script from "./contractOverviewTable.vue?vue&type=script&lang=ts"
export * from "./contractOverviewTable.vue?vue&type=script&lang=ts"

import "./contractOverviewTable.vue?vue&type=style&index=0&id=3b4addd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__